/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Modal')
    .factory('modalAction', ['$modal', function ($modal) {
        return function($scope, attrs) {
            var
                modalInstance = $modal.open(angular.extend({}, attrs, {
                        domOptions: attrs,
                        controller: attrs['modalController'],
                        size: attrs['modalSize'],
                        windowClass: attrs['modalClass'] || (attrs['modalAction'] + '-dialog'),
                        backdrop: 'static',
                        keyboard: false
                    }));

            return modalInstance.result;
        }
    }]);


 
 
